import React from "react";

import logoOberflex from "../images/brands/oberflex-black.svg";
import logoMarotte from "../images/brands/marotte-black.svg";
import logoPurePaper from "../images/brands/purepaper-black.svg";
import logoObersurface from "../images/brands/obersurfaces.svg";

const ModelExportFooter = props => (
  <footer className="flex f7">
    <div className="w-70">
      <div className="w-180 mb1">
        <img src={logoObersurface} alt="OberSurfaces" />
      </div>
      <div className="mb02">Longeville en Barrois</div>
      <div className="mb02">55014 Bar-le-Duc Cedex - France</div>
      <div className="mb02">Tél. +33 (0)3 29 76 77 78</div>
      <div className="mb02">www.ober-surfaces.com</div>
    </div>
    <div className="w-30 flex items-end justify-between">
      <img className="w3" src={logoOberflex} alt="Marotte" />
      <img className="w3" src={logoMarotte} alt="Marotte" />
      <img className="w3" src={logoPurePaper} alt="Marotte" />
    </div>
  </footer>
);

export default ModelExportFooter;



// WEBPACK FOOTER //
// ./src/components/ModelExportFooter.js